<template>
  <div>
    <FiltroNomeEstabelecimento 
      @filtrar-estabelecimentos="adicionarFiltro"
    />
    <v-divider />
    <FiltroEstadoCidade
      @filtrar-estado-cidade="adicionarFiltro"
    />
    <v-divider />
    <FiltroCategoriaEstabelecimento
      @filtrar-categorias-estabelecimento="adicionarFiltro"
    />
    <v-divider />
    <FiltroLojaTeste
      @filtrar-loja-teste="adicionarFiltro"
    />
    <v-divider />
    <FiltroStatusPagamento
      @filtrar-status-pagamentos="adicionarFiltro"
    />
    <v-divider />
    <FiltroPagamentoOnline
      @filtrar-pagamento-online="adicionarFiltro"
    />
    <v-divider />
    <FiltroPedidoGerente
      @filtrar-pedido-gerente="adicionarFiltro"
    />
    <v-divider />
    <FiltroModulos
      @filtrar-modulos="adicionarFiltro"
    />
    <v-divider />
    <FiltroPeriodoPedidos
      @filtrar-periodo-pedidos="adicionarFiltro"
    />
    <v-divider />
    <FiltroDataCriacao
      @filtrar-data-criacao="adicionarFiltro"
    />
    <v-divider />
    <FiltroSaudacao
      @filtrar-saudacoes="adicionarFiltro"
    />
    <v-divider />
    <FiltroVersaoApp
      @filtrar-versao-app="adicionarFiltro"
    />
    <v-divider />
    <FiltroUltimoAcesso
      @filtrar-ultimo-acesso="adicionarFiltro"
    />
    <v-divider />
    <FiltroPlano
      @filtrar-planos="adicionarFiltro"
    />
    <v-divider />
    <FiltroStatusAtendimento
      @filtrar-status-atendimento="adicionarFiltro"
    />
    <v-divider />
    <FiltroDataAtivacao
      @filtrar-data-ativacao="adicionarFiltro"
    />
    <v-divider />
    <FiltroRepresentante
      @filtrar-representante="adicionarFiltro"
    />
    <v-divider />
    <FiltroPedidosRecorrentes 
      @filtrar-pedidos-recorrentes="adicionarFiltro"
    />
    <v-divider />
    <FiltroLojaAberta
      @filtrar-loja-aberta="adicionarFiltro"
    />
    <v-btn color="success" @click="filtrar">Filtrar</v-btn>
  </div>
</template>

<script>
import FiltroNomeEstabelecimento from './Estabelecimentos/FiltroNomeEstabelecimento'
import FiltroEstadoCidade from './Estabelecimentos/FiltroEstadoCidade'
import FiltroCategoriaEstabelecimento from './Estabelecimentos/FiltroCategoriaEstabelecimento'
import FiltroLojaTeste from './Estabelecimentos/FiltroLojaTeste'
import FiltroStatusPagamento from './Estabelecimentos/FiltroStatusPagamento'
import FiltroPagamentoOnline from './Estabelecimentos/FiltroPagamentoOnline'
import FiltroPedidoGerente from './Estabelecimentos/FiltroPedidoGerente'
import FiltroModulos from './Estabelecimentos/FiltroModulos'
import FiltroPeriodoPedidos from './Estabelecimentos/FiltroPeriodoPedidos'
import FiltroVersaoApp from './Estabelecimentos/FiltroVersaoApp'
import FiltroDataCriacao from './Estabelecimentos/FiltroDataCriacao'
import FiltroDataAtivacao from './Estabelecimentos/FiltroDataAtivacao'
import FiltroSaudacao from './Estabelecimentos/FiltroSaudacao'
import FiltroUltimoAcesso from './Estabelecimentos/FiltroUltimoAcesso'
import FiltroPlano from './Estabelecimentos/FiltroPlano'
import FiltroStatusAtendimento from './Estabelecimentos/FiltroStatusAtendimento'
import FiltroRepresentante from './Estabelecimentos/FiltroRepresentante'
import FiltroPedidosRecorrentes from './Estabelecimentos/FiltroPedidosRecorrentes'
import FiltroLojaAberta from './Estabelecimentos/FiltroLojaAberta'

export default {
  name: 'FiltroEstabelecimentos',
  components: {
    FiltroNomeEstabelecimento,
    FiltroEstadoCidade,
    FiltroCategoriaEstabelecimento,
    FiltroLojaTeste,
    FiltroStatusPagamento,
    FiltroPagamentoOnline,
    FiltroPedidoGerente,
    FiltroModulos,
    FiltroPeriodoPedidos,
    FiltroDataCriacao,
    FiltroSaudacao,
    FiltroVersaoApp,
    FiltroUltimoAcesso,
    FiltroPlano,
    FiltroStatusAtendimento,
    FiltroRepresentante,
    FiltroPedidosRecorrentes,
    FiltroLojaAberta,
    FiltroDataAtivacao
  },
  data() {
    return {
      filtros: {}
    }
  },
  methods: {
    adicionarFiltro(value) {
      this.filtros = { 
        ...this.filtros, 
        ...value 
      }
      const { data_inicio, data_fim, categorias_estabelecimento } = value
      if (
        data_inicio !== null && data_inicio !== undefined &&
        data_fim !== null && data_fim !== undefined
      ) {
        this.$emit('datas', {
          data_inicio, data_fim
        })
      }
      if (categorias_estabelecimento !== undefined) {
        this.$emit('quantidade-categorias', categorias_estabelecimento.length)
      }
    },
    filtrar() {
      const filtros = this.serializarFiltros()
      this.$emit('filtrar', filtros)
    },
    serializarFiltros() {
      let ids = this.serializarArray('ids', true)
      let args = `data_inicio: "${this.filtros.data_inicio}"`
      args += this.serializarCampo('data_fim', true)
      args += ids
      args += this.serializarArray('pagamento_online')
      args += this.serializarArray('pedido_gerente')

      if (ids === ', ids: []') {
        args += this.serializarEstadoCidade()
        args += this.serializarModulos()
        args += this.serializarUltimoAcesso()

        args += this.serializarCampo('status')
        args += this.serializarCampo('loja_teste')
        args += this.serializarCampo('representante', true)
        args += this.serializarCampo('pedidos_recorrentes')
        args += this.serializarCampo('loja_aberta')

        args += this.serializarArray('categorias_estabelecimento', true)
        args += this.serializarArray('status_pagamento')
        args += this.serializarArray('saudacoes')
        args += this.serializarArray('planos_estabelecimento', true)
        args += this.serializarArray('status_atendimento', true)

        args += this.serializarComparador('comparador_pedidos', 'quantidade_pedidos')
        args += this.serializarComparador('comparador_versao', 'versao_app', true)
        let cmpCriacao = this.serializarComparador('comparador_criacao', 'data_criacao_inicio', true)
        if (cmpCriacao !== '') {
          cmpCriacao += this.serializarCampo('data_criacao_fim', true)
          args += cmpCriacao
        }
        let cmpAtivacao = this.serializarComparador('comparador_ativacao', 'data_ativacao_inicio', true)
        if (cmpAtivacao !== '') {
          cmpAtivacao += this.serializarCampo('data_ativacao_fim', true)
          args += cmpAtivacao
        }
      }
      return args
    },
    serializarArray(campo, str = false) {
      let arr = this.filtros[campo]
      let itens = ''
      if (arr !== undefined) {
        if (arr.length > 0) {
          itens += str ? `"${arr[0]}"` : `${arr[0]}`
        }
        for (let i = 1; i < arr.length; i ++) {
          itens += str ? `, "${arr[i]}"` : `, ${arr[i]}`
        }
      }
      return `, ${campo}: [${itens}]`
    },
    serializarCampo(campo, str = false) {
      let item = this.filtros[campo]
      let retorno = ''
      if (item !== undefined && item !== null) {
        retorno = `, ${campo}: `
        retorno += str ? `"${item}"` : `${item}`
      }
      return retorno
    },
    serializarEstadoCidade() {
      const { cidade, estado } = this.filtros
      if (cidade !== undefined && cidade !== null) {
        return `, cidade: "${cidade}"`
      }
      if (estado !== undefined && estado !== null) {
        return `, estado: "${estado}"`
      }
      return ''
    },
    serializarComparador(comparador, campo, str = false) {
      const c = this.filtros[comparador]
      const f = this.filtros[campo]
      let retorno = ''
      if (c !== undefined && c !== null) {
        if (c === 'x') {
          retorno += `, ${comparador}: "${c}" `  
        }
        else {
          retorno += `, ${comparador}: "${c}", ${campo}: `
          retorno += str ? `"${f}"` : `${f}`
        }
      }
      return retorno  
    },
    serializarModulos() {
      let retorno = ''
      const { comanda_facil, delivery, agendamento } = this.filtros
      if (comanda_facil) {
        retorno += `, comanda_facil: true`
      }
      if (delivery) {
        retorno += `, delivery: true`
      }
      if (agendamento) {
        retorno += `, agendamento: true`
      }
      return retorno
    },
    serializarUltimoAcesso() {
      if (this.filtros.comparador_ultimo_acesso === 'x') {
        return ', comparador_ultimo_acesso: "x"'
      }
      return this.serializarComparador('comparador_ultimo_acesso', 'data_ultimo_acesso', true)
    }
  }
}
</script>
